import styles from 'owa-mail-listitem-styles/lib/scss/MailListItem.scss';
import classnamesBind from 'classnames/bind';
import { observer } from 'mobx-react-lite';
import { getDensityModeString } from 'owa-fabric-theme';
import { isFeatureEnabled } from 'owa-feature-flags';
import { getMessageListTextStyle } from 'owa-mail-listitem-styles/lib/utils/getMessageListTextStyle';
import { formatRelativeDate } from 'owa-observable-datetime';
import * as React from 'react';

const classNames = classnamesBind.bind(styles);

export interface MailListItemTimestampProps {
    isSnoozed?: boolean;
    isSingleLine?: boolean;
    isUnread?: boolean;
    lastDeliveryTimestamp?: string;
    returnTime: string;
}

export default observer(function MailListItemTimestamp(props: MailListItemTimestampProps) {
    const {
        isSnoozed = false,
        isSingleLine = false,
        isUnread = false,
        lastDeliveryTimestamp = '',
        returnTime,
    } = props;

    const columnHeadersEnabled = isFeatureEnabled('mon-tri-columnHeadersSlv') && isSingleLine;
    const hasDensityNext = isFeatureEnabled('mon-densities');

    let formattedDate = '';

    // shared styles
    let timestampStyles = classNames(
        columnHeadersEnabled ? styles.timestampSLVWithHeaders : undefined
    );

    /* snoozed item timestamp */
    if (isSnoozed) {
        if (!returnTime) {
            return null;
        }

        formattedDate = formatRelativeDate(returnTime);

        // apply snoozed item timestamp specific styles
        timestampStyles = classNames(
            timestampStyles,
            styles.scheduleTime,
            columnHeadersEnabled ? styles.timestampSLVWithHeaders : undefined
        );
    } /* normal timestamp */ else {
        if (returnTime) {
            return null;
        }

        formattedDate = formatRelativeDate(lastDeliveryTimestamp);

        const densityModeString = getDensityModeString();

        timestampStyles = classNames(
            timestampStyles,
            styles.timestamp,
            isSingleLine ? styles.timestampSLV : undefined,
            !isSingleLine && isUnread ? styles.timestampUnread : undefined,
            hasDensityNext &&
                (isUnread ? styles.timestampUnreadNext : styles.secondRowThreeColumnRead),
            hasDensityNext && getMessageListTextStyle('Minor', densityModeString),
            columnHeadersEnabled ? styles.timestampSLVWithHeaders : undefined
        );
    }

    return (
        <span className={timestampStyles} title={formattedDate}>
            {formattedDate}
        </span>
    );
});
